import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { WorkerPoolsTableRow } from "../types";

const WorkerPoolsTableWorkersCell = ({
  item: row,
  ...cellProps
}: TableSimpleCellProps<WorkerPoolsTableRow>) => {
  if (row.kind === "public") {
    const { parallelism } = row.publicWorkerPool;

    return (
      <TableSimpleCell {...cellProps}>
        <TableCellText>{parallelism > 0 ? `up to ${parallelism}` : parallelism}</TableCellText>
      </TableSimpleCell>
    );
  }

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{row.workerPool.workersCount}</TableCellText>
    </TableSimpleCell>
  );
};

export default WorkerPoolsTableWorkersCell;
